/**
 * Turning a refused sync operation into words (ADR-0011: codes on the wire,
 * translated on screen). Every code the API can return for /sync/ops or
 * /attachments has a message under `ui.capture.rejected.<CODE>`; anything
 * else falls back to `ui.capture.rejected.UNKNOWN`.
 */
import type { ValidationIssue } from '@sss/form-engine';

export const KNOWN_REJECTIONS = [
  'LOCK_LOST',
  'LOCK_HELD',
  'SURVEY_REASSIGNED',
  'SURVEY_CANCELLED',
  'VALIDATION_FAILED',
  'VALIDATION_ERROR',
  'INVALID_STATE',
  'FORBIDDEN',
  'NOT_FOUND',
  'SITE_INACTIVE',
  'IMMUTABLE_FIELDS',
  'INVALID_TEMPLATE_VERSION',
  'OP_ID_CONFLICT',
  'ATTACHMENT_ID_CONFLICT',
  'UNSUPPORTED_TYPE',
  'TOO_LARGE',
  'PAYLOAD_TOO_LARGE',
  'FILE_REQUIRED',
  'UNKNOWN_OP',
] as const;

/** i18n key for a rejection code. */
export function rejectionKey(code: string | undefined | null): string {
  return `ui.capture.rejected.${code && (KNOWN_REJECTIONS as readonly string[]).includes(code) ? code : 'UNKNOWN'}`;
}

/** The lock is with another device or person: offer "Take over". */
export function isLockRejection(code: string | undefined | null): boolean {
  return code === 'LOCK_LOST' || code === 'LOCK_HELD';
}

/** Validation issues sent with a VALIDATION_FAILED rejection (`details.issues`), if well-formed. */
export function issuesFromDetails(details: unknown): ValidationIssue[] {
  const issues = (details as { issues?: unknown } | null | undefined)?.issues;
  if (!Array.isArray(issues)) return [];
  return issues.filter(
    (i): i is ValidationIssue =>
      !!i && typeof i === 'object' && typeof (i as ValidationIssue).sectionCode === 'string' && typeof (i as ValidationIssue).ref === 'string' && typeof (i as ValidationIssue).code === 'string',
  );
}
